<template>
  <div class="mt-3">
    <!-- ----------------------------------------------------- -->
    <!-- main headings -->
    <!-- ----------------------------------------------------- -->
    <div class="mt-3">
      <div class="row">
        <p class="bb-sheet-title">TRAITS</p>
      </div>
    </div>
    <div
      v-if="isReady"
      class="container-fluid mt-3 mb-2"
    >
      <!-- ----------------------------------------------------- -->
      <!-- table headings -->
      <!-- ----------------------------------------------------- -->
      <div class="row">
        <div class="col-4 text-center">
          <p class="bb-hdg mt-2 mb-3">Source</p>
        </div>
        <div class="col-7 text-center">
          <p class="bb-hdg mt-2 mb-3">Description</p>
        </div>
      </div>
      <!-- ----------------------------------------------------- -->
      <!-- Data Rows -->
      <!-- ----------------------------------------------------- -->
      <div
        class="row mt-3 mb-3 align-items-center"
        v-for="trait in traits"
        :key="trait.source"
      >
        <!-- ----------------------------------------------------- -->
        <!-- source -->
        <!-- ----------------------------------------------------- -->
        <div class="col-4 text-center">
          <div class="form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control text-left"
                :value="trait.source"
                :id="`${trait.source}_source`"
                disabled
              />
              <label
                class="readonly bb-float-label optional"
                :for="`${trait.source}_source`"
                >Source</label
              >
            </div>
          </div>
        </div>
        <!-- ----------------------------------------------------- -->
        <!-- description (no tooltip) -->
        <!-- ----------------------------------------------------- -->
        <div class="col-7 text-left">
          <div class="form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control"
                :value="trait.description"
                :id="`${trait.source}_description`"
                disabled
              />
              <label
                class="readonly bb-float-label optional"
                :for="`${trait.source}_description`"
              >
                Description
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import copyObjectNoRef from '../helpers/copyObjectNoRef'

export default {
  name: 'CharacterSheetTraits',
  //========================================
  // props
  //-------
  props: {
    character: {
      type: Object,
      required: true,
    },
  },
  //========================================================
  // components
  //------------
  components: {},
  //========================================================
  // setup
  //-------
  setup() {},
  //========================================================
  // watch
  //-------
  watch: {
    //-------------------------------------------------------
    // watch character for immediate updates from controller
    //-------------------------------------------------------
    character: {
      handler(newChar) {
        if (!newChar) return
        // reload local_character for new/updated character
        this.local_character = copyObjectNoRef(this.character)
        // set traits
        this.traits = this.getDisplayTraits(this.character?.traits || [])
      },
      deep: true,
      immediate: true,
    },
  },
  //========================================================
  // data
  //------
  data() {
    return {
      local_character: null,
      traits: [],
    }
  },
  //========================================================
  // computed
  //-----------
  computed: {
    isReady() {
      if (this.local_character != null) {
        return true
      }
      return false
    },
  },
  //========================================================
  // methods
  //---------
  methods: {
    getDisplayTraits(traits) {
      if (!Array.isArray(traits)) return []

      return traits.filter((trait) => {
        if (!trait) return false

        const description = trait.description
        if (description == null) return false
        if (typeof description === 'string' && description.trim() === '')
          return false

        return true
      })
    },
    computedDescription(description) {
      if (!this.character || !description || typeof description !== 'string')
        return false
      const val = description
      return val.trim() !== ''
    },
  },
  //========================================================
  // mounted
  //---------
  mounted() {},
}
</script>
